<div mat-dialog-content>
    <h3>{{ this.pageName | translate}}</h3>
</div>
<vias-form #formDialog
[formItems]="formItems"
[hasSubmitBtn]="this.hasSubmitButton"
[submitBtnText]="this.submitBtnText"
[numLocale]="numLocale"
(formSubmit)="onSubmit($event)"
(formItemClick)="formItemClickHandler($event)"
></vias-form>